import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { colors, spacing, shadows } from '../theme/index';
import API_BASE_URL from '../config/api';

function PasswordGate({ children }) {
  const [password, setPassword] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const validPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'Musavvir20';

  // Auto-login as admin when password gate is unlocked
  const autoLoginAsAdmin = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: 'admin@surgical.com',
          password: 'admin123'
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.data.token);
        localStorage.setItem('user', JSON.stringify(data.data.user));
        console.log('✅ Auto-logged in as admin');
        // Reload to pick up the new token
        setTimeout(() => window.location.reload(), 500);
        return true;
      }
    } catch (err) {
      console.log('Auto-login error:', err.message);
    }
    return false;
  };

  // Check if password was already entered in this session
  useEffect(() => {
    const sessionUnlocked = sessionStorage.getItem('adminPanelUnlocked');
    if (sessionUnlocked === 'true') {
      setIsUnlocked(true);
      // Auto-login if not already logged in
      const token = localStorage.getItem('token');
      if (!token) {
        autoLoginAsAdmin();
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password === validPassword) {
      setIsLoggingIn(true);
      // Auto-login before unlocking
      await autoLoginAsAdmin();
      setIsUnlocked(true);
      sessionStorage.setItem('adminPanelUnlocked', 'true');
      setPassword('');
      setIsLoggingIn(false);
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  if (!isUnlocked) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: colors.background,
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          style={{
            padding: spacing.xl,
            borderRadius: '12px',
            backgroundColor: '#fff',
            boxShadow: shadows.lg,
            maxWidth: '400px',
            width: '100%',
          }}
        >
          <h1
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: spacing.md,
              color: colors.textPrimary,
            }}
          >
            🔐 Admin Access
          </h1>
          <p style={{ color: colors.textSecondary, marginBottom: spacing.lg }}>
            Enter the password to proceed
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={isLoggingIn}
              style={{
                width: '100%',
                padding: spacing.md,
                border: `2px solid ${colors.border}`,
                borderRadius: '8px',
                fontSize: '16px',
                marginBottom: spacing.md,
                boxSizing: 'border-box',
                fontFamily: 'inherit',
                opacity: isLoggingIn ? 0.6 : 1,
              }}
              autoFocus
            />

            {error && (
              <p
                style={{
                  color: colors.error,
                  fontSize: '14px',
                  marginBottom: spacing.md,
                }}
              >
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={isLoggingIn}
              style={{
                width: '100%',
                padding: spacing.md,
                backgroundColor: isLoggingIn ? '#ccc' : colors.primary,
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: isLoggingIn ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s',
                opacity: isLoggingIn ? 0.7 : 1,
              }}
              onMouseEnter={(e) => {
                if (!isLoggingIn) {
                  e.target.style.backgroundColor = colors.primaryDark || '#00875a';
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoggingIn) {
                  e.target.style.backgroundColor = colors.primary;
                }
              }}
            >
              {isLoggingIn ? 'Unlocking...' : 'Unlock'}
            </button>
          </form>

          <p style={{ color: colors.textSecondary, fontSize: '12px', marginTop: spacing.lg }}>
            This session will remain unlocked until you close the browser.
          </p>
        </motion.div>
      </div>
    );
  }

  return children;
}

export default PasswordGate;
